import React from "react";

export const LoadingItem = () => {
    return(
        <div className="loading-overlay">
            <div className="loading-spinner"/>
        </div>
    )
}